@if (call.isPostProcessingComplete) {
  @if (editor !== null && hasInitiallySynced) {
    <div class="editor-container">
      <tiptap-editor class="editor" [editor]="editor"></tiptap-editor>
      <tiptap-bubble-menu [editor]="editor" [options]="bubbleMenuOptions" [updateDelay]="100">
        <div class="editor-bubble-menu">
          <button mat-icon-button type="button" (click)="toggleBoldOnSelection()">
            <mat-icon>format_bold</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="toggleItalicOnSelection()">
            <mat-icon>format_italic</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="toggleBulletList()">
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="toggleOrderedList()">
            <mat-icon>format_list_numbered</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="decreaseIndent()">
            <mat-icon>format_indent_decrease</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="increaseIndent()">
            <mat-icon>format_indent_increase</mat-icon>
          </button>
          @if (canUserEdit) {
            <div class="bubble-menu-divider"></div>
            <button mat-button type="button" [matMenuTriggerFor]="aiMenu">
              <mat-icon class="ai-actions-icon">auto_awesome</mat-icon>
              {{ 'EDITOR.AI_ACTIONS' | translate }}
            </button>
            <mat-menu #aiMenu="matMenu" class="ai-actions-menu">
              @for (actionConfig of aiActionsConfig; track actionConfig.action) {
                <button mat-menu-item (click)="performAiAction(actionConfig.action)">
                  <mat-icon>{{ actionConfig.icon }}</mat-icon>
                  {{ actionConfig.i18nKey | translate }}
                </button>
              }
            </mat-menu>
          }
        </div>
      </tiptap-bubble-menu>
      @if (showWordCount$ | async) {
        <mat-chip class="word-count-badge">
          <span class="word-count">{{ editor.storage.characterCount.words() }}</span> {{ 'EDITOR.WORD_COUNT.LABEL' | translate }}
        </mat-chip>
      }
    </div>
  } @else {
    <div class="centered-content">
      <mat-spinner diameter="40"></mat-spinner>
      <span class="loading-text">{{ 'CALLS.MINUTES_LOADING_MESSAGE' | translate }}</span>
    </div>
  }
} @else {
  <div class="centered-content">
    @if (call.isMinutesGenerationOngoing) {
      <mat-spinner diameter="40"></mat-spinner>
      <span class="loading-text">{{ 'CALLS.MINUTES_PROCESSING_MESSAGE' | translate }}</span>
    } @else {
      <h1>{{ 'CALLS.MINUTES_WILL_BE_SHOWN_HERE' | translate }}</h1>
    }
  </div>
}
